import React from "react";
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  Polyline,
  Marker,
  InfoWindow,
  InfoBox,
  DirectionsRenderer
} from "react-google-maps";

import { getData } from "../../services/index";
import { auth, db, messaging } from "../../firebase";
import { getToken, getMessaging, onMessage } from "firebase/messaging";
import { Modal } from 'antd';

class Map extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
		progress: [],
		velocity: 100,
		initialDate: new Date(),
		path: [],
		latitude: 0,
		longitude: 0,
		busPositions: [],
		route_list: [],
		show_map_model:false,
		bus_info:[],
		bus_number:'',
		selectedMarker: null,
		directions: null
    };
  }
  
  componentDidMount = () => {
    this.fetchBusPositions(); // Fetch bus positions initially
    this.interval = setInterval(this.fetchBusPositions, 2000);
  };
  
 
  componentWillUnmount = () => {
    clearInterval(this.interval);
  };

  fetchBusPositions = () => {
    this.checkData();
  };

  componentWillMount = () => {
	 this.getStopList();
     this.checkData();
  };
  
  getStopList=()=>{
	  if (localStorage.getItem("schoolData")) {
		  var url = window.location.pathname.split("/");
		 
		  if (url[4]) {
			if (url[4] > 0) {
			  var route_type = url[3];
			  var route_id = url[4];
			  var app = { route_id: route_id,route_type:route_type };
			  getData("Transport/ongoing_route_details", app).then((result) => {
				let responseJson = result;
				if (responseJson.data) {
				  if (result["status"] == 200) {
					if(result["data"].length>0){
						this.setState({
							route_list:result["data"][0]['stop_array'],
							latitude: result["data"][0]['stop_array'][0]["stop_latitude"],
							longitude: result["data"][0]['stop_array'][0]["stop_longitude"],
						});
					} 
				  }
				}
			  });
			} 
		  }		  
	  }
  }

  checkData() {
	if (localStorage.getItem("schoolData")) {
      //var app = { route_id: route_id,route_type:route_type };
      var app = { user_id: "106", school_id: "47" };
      getData("Transport/get_live_bus_list", app).then((result) => {
        let responseJson = result;
        if (responseJson.data) {
          if (result["status"] == 200) {
            if (result["data"].length > 0) {
              this.setState({
                latitude: result["data"][0]["lat"],
                longitude: result["data"][0]["lng"],
                busPositions: result["data"],
              });
            }
          } else {
            this.setState({
              path: [],
            });
          }
        }
      });
    }
  }
  
    handleMarkerClick=(bus)=>{
		var bus_number='';
		var attributes=bus.attributes;
		var deviceAttributes=JSON.parse(attributes.deviceAttributes);
		this.setState({ bus_info: bus, show_map_model:true,bus_number:deviceAttributes.number });
    } 
	
	handleOk = e => {
		this.setState({
			bus_number:'',
			show_map_model: false,
			bus_info:[]
		})
	}

	handleCancel = e => {
		this.setState({
			bus_number:'',
			show_map_model: false,
			bus_info:[]
		})
	}
	

	handleInfoWindowClose = () => {
		this.setState({ selectedMarker: null });
	}
	

	render = () => {
		const icon = {
			url: "/assets/images/bus.png",
			scaledSize: new window.google.maps.Size(80, 80),
			anchor: { x: 40, y: 40 },
		};
		const { busPositions,bus_info,bus_number,route_list,selectedMarker,directions } = this.state;
		
		const polylinePath = route_list.map(marker => ({
		  lat: marker.stop_latitude,
		  lng: marker.stop_longitude
		}));
		
		const polylineOptions = {
		  strokeColor: '#0000FF',
		  strokeOpacity: 0.8,
		  strokeWeight: 2,
		  icons: [
			{
			  icon: {
				path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
				scale: 3
			  },
			  offset: '100%',
			  repeat: '100px'
			}
		  ]
		};
		

		return (
			<div class="map_model">
			<Modal 
				 title="Bus Information"
				 visible={this.state.show_map_model}
				 className="map_model"
				 onOk={this.handleOk}
				 onCancel={this.handleCancel}
				>
				<div class="student_box">
					<table class="student_list">
						<tbody>
						<tr>
							<td>Bus Name</td>
							<td>&nbsp;: {bus_info.name}</td>
						</tr>
						<tr>
							<td>Bus Number</td>
							<td>&nbsp;: {bus_number}</td>
						</tr>
						<tr>
							<td>Status</td>
							<td>&nbsp;: {bus_info.status}</td>
						</tr>
						</tbody>
					</table>
				</div>
			</Modal>
				{(this.state.latitude>0 && route_list.length>0) && (
				  <GoogleMap
					defaultZoom={16}
					defaultCenter={{
					  lat: this.state.latitude,
					  lng: this.state.longitude,
					}}
				  >
				  {route_list.map(busStop => ( 
					<Marker
						key={busStop.stop_id}
						position={{ lat: busStop.stop_latitude, lng: busStop.stop_longitude }}
						label={busStop.stop_no}
						//onClick={() => this.handleMarkerClick(busStop)}
						
					  >
						
					</Marker>
				  ))}
				    <Polyline
					  //path={polylinePath}
					  //options={polylineOptions}
					/>
					{busPositions.map((bus) => (
					 <div key={bus.id}>
					    <Polyline
						  path={bus.route}
						  options={{
							strokeColor: 'blue',
							strokeOpacity: 2.0,
							strokeWeight: 2,
							icons: bus.route.map((_, index) => ({
							  icon: {
								path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
								scale: 1.5
							  },
							  offset: `${100 / (bus.route.length - 1) * index}%`
							}))
						  }}
						/>
					    <Marker 
							position={{ lat: bus.lat, lng: bus.lng }}
							icon={{
							url: 'https://school.kidzonia.co.in/assets/icon/bus-stop.png',
							scaledSize: new window.google.maps.Size(66, 66),
							anchor: new window.google.maps.Point(33, 33),
						  }}
						  onClick={() => this.handleMarkerClick(bus)}
						>
						
						</Marker>
					  </div>
					))}
				  </GoogleMap>
				)}
				
			</div>
		);
	}
}

const MapComponent = withScriptjs(withGoogleMap(Map));

export default () => (
  <MapComponent
    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCqURvpBOM-f6MHU5TkeJ2wLsagZZCL7ns&v=3.exp&libraries=geometry,drawing,places"
    loadingElement={<div style={{ height: `100%` }} />}
    containerElement={
      <div style={{ height: window.innerHeight - 250, width: "100%" }} />
    }
    mapElement={<div style={{ height: `100%` }} />}
  />
);
